import Vue from "vue";
import Router from "vue-router";

// Containers
import Public from "@/containers/Public";
import Private from "@/containers/Private";
import SelfAssessment from "@/containers/SelfAssessment";
import OpinionSurvey from "@/containers/OpinionSurvey";
import Reports from "@/containers/Reports";
import Configuration from "@/containers/Configuration";
import Pdf from "@/containers/Pdf";
import Resources from "@/containers/Resources";

// Components
import Pillars from "@/components/public/PublicPillars";
import Login from "@/components/public/PublicLogin";

import Home from "@/components/Home";
import Logout from "@/components/Logout";

import OpinionSurveySendInvitations from "@/components/OpinionSurveySendInvitations";
import OpinionSurveyManagment from "@/components/OpinionSurveyManagment";
import OpinionSurveyCalculator from "@/components/OpinionSurveyCalculator";

import ViolenceSurveyCalculator from "@/components/ViolenceSurveyCalculator";

import SelfAssessmentGeneralInformation from "@/components/modules/self-assesment/SelfAssessmentGeneralInformation";
import SelfAssessmentStaff from "@/components/modules/self-assesment/SelfAssessmentStaff";
import SelfAssessmentLaborConditions from "@/components/modules/self-assesment/SelfAssessmentLaborConditions";
import SelfAssessmentHumanResources from "@/components/modules/self-assesment/SelfAssessmentHumanResources";
import SelfAssessmentEmploymentPolicies from "@/components/modules/self-assesment/SelfAssessmentEmploymentPolicies";
import SelfAssessmentSubmitReview from "@/components/modules/self-assesment/SelfAssessmentSubmitReview";
import ReportsGenderGap from "@/components/ReportsGenderGap";
import ReportsGenderGapPdf from "@/components/ReportsGenderGapPdf";
import ReportsGenderGapPillar from "@/components/ReportsGenderGapPillar";
import ReportsGenderGapIndicator from "@/components/ReportsGenderGapIndicator";
import ReportsManagementReport from "@/components/ReportsManagementReport";
import ReportsManagementReportPdf from "@/components/ReportsManagementReportPdf";
import ReportsOpinionSurveyPDF from "@/components/ReportsOpinionSurveyPDF";
import ReportsOrganizationalViolencePdf from "@/components/ReportsOrganizationalViolencePdf";

import ReportsComparative from "@/components/ReportsComparative";
import ReportsComparativePillar from "@/components/ReportsComparativePillar";
import ReportsOpinionSurvey from "@/components/ReportsOpinionSurvey";
import ReportsViolenceSurvey from "@/components/ReportsViolenceSurvey";
import ResourcesDownloads from "@/components/ResourcesDownloads";
import ConfigurationAccessControl from "@/components/modules/administration/ConfigurationAccessControl";

import store from "../store";
import ReportsConsolidated from "../components/ReportsConsolidated";
import ReportsConsolidatedPillar from "../components/ReportsConsolidatedPillar";
import ReportsConsolidatedIndicator from "../components/ReportsConsolidatedIndicator";
import Evaluation from "../containers/Evaluation";
import EvaluationModelsRequirements from "../components/modules/evaluation/admin/EvaluationModelsRequirements";
import EvaluationModels from "../components/modules/evaluation/admin/EvaluationModels";
import EvaluationReport from "../components/modules/evaluation/report/EvaluationReport";
import EvaluationReportPDF from "../components/modules/evaluation/report/EvaluationReportPDF";
import EvaluationReportPDFHeader from "../components/modules/evaluation/report/EvaluationReportPDFHeader";
import EvaluationReportPDFFooter from "../components/modules/evaluation/report/EvaluationReportPDFFooter";
import CreateEvaluation from "../components/modules/evaluation/audit/CreateEvaluation";
import EvaluationEvaluate from "../components/modules/evaluation/audit/EvaluationEvaluate";
import EvaluationOrganization from "../components/modules/evaluation/organization/EvaluationOrganization";
import CreateEvaluationOrganization from "../components/modules/evaluation/organization/CreateEvaluationOrganization";
import EvaluationReportList from "../components/modules/evaluation/report/EvaluationReportList";
import SnapshotsCache from "../components/SnapshotsCache";
import WorkspaceSurveyManagement from "../components/WorkspaceSurveyManagement";
import WorkspaceSurvey from "../components/WorkspaceSurvey";
import WorkspaceSurveyContainer from "../containers/WorkspaceSurvey";
import ReportsComparativePDF from "../components/ReportsComparativePDF";
import ReportsOrganizationalViolence from "../components/ReportsOrganizationalViolence";
import ConfigurationCreateUser from "../components/modules/administration/ConfigurationCreateUser";
import ConfigurationWizard from "../components/modules/administration/businessCreation/ConfigurationWizard";
import ConfigurationWizardAdmin from "../components/modules/administration/ConfigurationWizardAdmin";
import ConfigurationAccessControlTemplate
  from "../components/modules/administration/ConfigurationAccessControlTemplate";
import ConfigurationCreateAccessControl from "../components/modules/administration/ConfigurationCreateAccessControl";
import IndicaListFromUrl from "../utils/forms/indica-list-from-url";
import IndicaDescription from "../utils/forms/indica-description";
import {ConfigurationTableList} from "../utils/forms/tablesConfiguration";
import LabelsManagement from "../components/modules/administration/languages/LabelsManagement.vue";
import LabelsRegenerateCache from "../components/modules/administration/languages/LabelsRegenerateCache.vue";
import LabelsBackup from "../components/modules/administration/languages/LabelsBackup.vue";
import LabelsExport from "../components/modules/administration/languages/LabelsExport.vue";
import LabelsImport from "../components/modules/administration/languages/LabelsImport.vue";
import Languages from "../components/modules/administration/languages/Languages.vue";
import {axiosCall} from "../utils/axiosCall";
import DashboardContainer from "@/components/modules/dashboard/container/DashboardContainer.vue";
import Dashboard from "@/components/modules/new-dashboard/Dashboard.vue";
import * as Dashboard2 from "@/components/modules/dashboard/components/Dashboard.vue";
import TrackerImport from "@/components/modules/administration/tracker/TrackerImport.vue";
import TrackerBackup from "@/components/modules/administration/tracker/TrackerBackup.vue";
import TrackerDashboard from "@/components/modules/tracker-dashboard/Tracker-Dashboard.vue";
import TrackerTracker from "@/components/modules/tracker-dashboard/tracker-tracker.vue";
import TrackerContainer from "@/components/modules/tracker-dashboard/tracker-container.vue";
import {getFrontendUrl, getUrlForCurrentDomain} from "@/utils/urlConfig";

Vue.use(Router);

/* const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}*/

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    /* var date = new Date()*/
    // Expira la sesión despues de un día de iniciar sesión
    /*    if (store.getters.getExpirationDate < date.getTime()) {
      next('/')
    }*/
    next();
    return;
  }
  next("/");
};

const tableListRoutes = ConfigurationTableList.map((table) => ({
  path: `${table.name}/list`,
  name: table.name,
  component: IndicaListFromUrl,
  meta: {
    label: `label_${table.name}`,
    tableName: table.name,
    hideBusinessSelectorAndTitle: true,
  },
}));

const tableViewRoutes = ConfigurationTableList.map((table) => ({
  path: `${table.name}/view/:id`,
  name: table.name,
  component: IndicaDescription,
  meta: {
    label: `label_${table.name}`,
    tableName: table.name,
    hideBusinessSelectorAndTitle: true,
  },
}));

const router = new Router({
  // mode: 'history',
  scrollBehavior: function (to) {
    if (to.hash) {
      return {selector: to.hash};
    } else {
      return {x: 0, y: 0};
    }
  },
  routes: [
    {
      path: "/:lang/public-tracker-dashboard/",
      component: TrackerContainer,
      name: "publicTrackerDashboard",
      meta: {
        label: "label_tracker_dashboard_title",
        hideBusinessSelectorAndTitle: true,
        isEmbed: true,
      },
      children: [
        {
          path: "",
          name: "TrackerDashboard",
          component: TrackerDashboard,
          meta: {
            label: "label_tracker_dashboard_title",
            hideBusinessSelectorAndTitle: true,
            isEmbed: true,
          },
        },
        {
          path: "tracker",
          name: "Tracker",
          component: TrackerTracker,
          meta: {
            label: "label_tracker_dashboard_title",
            hideBusinessSelectorAndTitle: true,
            isEmbed: true,
          },
        },
      ],
    },
    {
      path: "/",
      name: "Public",
      component: Public,
      children: [
        {
          name: "login",
          path: "",
          component: Login,
        },
        {
          name: "Pillars",
          path: "pillars",
          component: Pillars,
        },
        {
          path: "login",
          name: "Login",
          component: Login,
        },
      ],
    },
    {
      path: "/pdf",
      name: "Pdf",
      component: Pdf,
      children: [
        {
          path: "gender-gap/:token/:business/:snapshot/:accountroleid/:lang?",
          name: "ReportsGenderGapPdf",
          component: ReportsGenderGapPdf,
        },
        {
          path: "management-report/:token/:business/:snapshot/:accountroleid/:lang?",
          name: "ReportsManagementReportPdf",
          component: ReportsManagementReportPdf,
        },
        {
          path: "opinion-survey/:currSection/:token/:business/:snapshot/:accountroleid/:lang?",
          name: "ReportsOpinionSurveyPDF/:token/:business/:snapshot/:accountroleid/:lang?",
          component: ReportsOpinionSurveyPDF,
        },
        {
          path: "organizational-violence/:token/:business/:snapshot/:accountroleid/:lang?",
          name: "ReportsOrganizationalViolencePdf/:token/:business/:snapshot/:accountroleid/:lang?",
          component: ReportsOrganizationalViolencePdf,
        },
        {
          path: "evaluation-report/:token/:businessId/:evaluationId/:accountroleid/:lang?",
          name: "EvaluationReportPDF/:token/:businessId/:evaluationId/:accountroleid/:lang?",
          component: EvaluationReportPDF,
        },
        {
          path: "evaluation-report/:token/:businessId/:evaluationId/:accountroleid/:lang?/Header",
          name: "EvaluationReportPDF/:token/:businessId/:evaluationId/:accountroleid/:lang?/Header",
          component: EvaluationReportPDFHeader,
        },
        {
          path: "evaluation-report/:token/:businessId/:evaluationId/:accountroleid/:lang?/Footer",
          name: "EvaluationReportPDF/:token/:businessId/:evaluationId/:accountroleid/:lang?/Footer",
          component: EvaluationReportPDFFooter,
        },
        {
          path: "comparative-report/:token/:accountroleid/:lang?",
          name: "ComparativeReportPDF/:token/:accountroleid/:lang?",
          component: ReportsComparativePDF,
        },
      ],
    },
    {
      path: "private",
      name: "Private",
      component: Private,
      beforeEnter: ifAuthenticated,
      children: [
        {
          path: "/home",
          name: "Home",
          component: Home,
          meta: {
            label: "sideMenu_home_caption",
            hideBusinessSelectorAndTitle: true,
          },
        },
        {
          path: "/logout",
          name: "Logout",
          component: Logout,
          meta: {
            label: "sideMenu_home_caption",
          },
        },
        // {
        //   path: '/profile',
        //   name: 'Profile',
        //   component: Profile,
        //   meta: {
        //     label: 'headerMenu_profile_caption'
        //   }
        // },
        {
          path: "/resources",
          name: "Resources",
          component: Resources,
          redirect: "/resources/downloads",
          meta: {
            label: "label_resources_title",
          },
          children: [
            {
              path: "downloads",
              name: "ResourcesDownloads",
              component: ResourcesDownloads,
              meta: {
                label: "label_sideMenu_resources_downloads",
              },
            },
            {
              path: "snapshotCache",
              name: "snapshotCache",
              component: SnapshotsCache,
              meta: {
                label: "SnapshotCache",
              },
            },
            {
              path: "/LabelsManagement",
              name: "LabelsManagement",
              component: LabelsManagement,
              meta: {
                label: "label_sideMenu_configuration_localization",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "/LabelsRegenerateCache",
              name: "LabelsRegenerateCache",
              component: LabelsRegenerateCache,
              meta: {
                label: "label_sideMenu_configuration_localization",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "/Languages",
              name: "Languages",
              component: Languages,
              meta: {
                label: "label_sideMenu_configuration_localization",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "/LabelsBackup",
              name: "LabelsBackup",
              component: LabelsBackup,
              meta: {
                label: "label_sideMenu_configuration_localization",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "/LabelsExport",
              name: "LabelsExport",
              component: LabelsExport,
              meta: {
                label: "label_sideMenu_configuration_localization",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "/LabelsImport",
              name: "LabelsImport",
              component: LabelsImport,
              meta: {
                label: "label_sideMenu_configuration_localization",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "/tracker-import",
              name: "TrackerImport",
              component: TrackerImport,
              meta: {
                label: "label_sideMenu_tracker_import",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "/tracker-backup",
              name: "TrackerBackup",
              component: TrackerBackup,
              meta: {
                label: "label_sideMenu_tracker_import",
                hideBusinessSelectorAndTitle: true,
              },
            },
          ],
        },
        {
          path: "/evaluation",
          name: "Evaluation",
          component: Evaluation,
          redirect: "/evaluation/evaluation-models",
          meta: {
            label: "label_evaluation_title",
            hideBusinessSelectorAndTitle: true,
          },
          children: [
            {
              path: "report/:idEvaluation",
              name: "EvaluationReport",
              component: EvaluationReport,
              meta: {
                label: "label_evaluation_title",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "reports",
              name: "ListReportsEvaluation",
              component: EvaluationReportList,
              meta: {
                label: "label_evaluation_title",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "evaluate/:idEvaluation",
              name: "EvaluateEvaluation",
              component: EvaluationEvaluate,
              meta: {
                label: "label_evaluation_title",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "Organization/:idEvaluation",
              name: "EvaluateOrganization",
              component: EvaluationOrganization,
              meta: {
                label: "label_evaluation_title",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "evidencesRequested",
              name: "EvidencesRequested",
              component: CreateEvaluationOrganization,
              meta: {
                label:
                  "label_evaluation_requirementEvaluation_evidencesRequested",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "create",
              name: "CreateEvaluation",
              component: CreateEvaluation,
              meta: {
                label: "label_evaluation_title",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "evaluation-models",
              name: "EvaluationModels",
              component: EvaluationModels,
              meta: {
                label: "label_sideMenu_evaluation_administrator_models_title",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: ":evaluationId",
              name: "EvaluationModelsRequirements",
              component: EvaluationModelsRequirements,
              meta: {
                label: "label_evaluation_administrator_model_name",
                hideBusinessSelectorAndTitle: true,
              },
            },
          ],
        },
        {
          path: "/dashboard",
          name: "DashboardContainer",
          component: DashboardContainer,
          meta: {
            label: "label_dashboard_title",
            hideBusinessSelectorAndTitle: true,
          },
          children: [
            {
              path: "",
              name: "Dashboard",
              component: Dashboard,
              meta: {
                label: "label_dashboard_title",
                hideBusinessSelectorAndTitle: true,
              },
            },
          ],
        },
        {
          path: "/tracker-dashboard",
          name: "TrackerDashboardContainer",
          component: TrackerContainer,
          meta: {
            label: "label_tracker_dashboard_title",
            hideBusinessSelectorAndTitle: true,
          },
          children: [
            {
              path: "",
              name: "TrackerDashboard",
              component: TrackerDashboard,
              meta: {
                label: "label_tracker_dashboard_title",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "tracker",
              name: "Tracker",
              component: TrackerTracker,
              meta: {
                label: "label_tracker_dashboard_title",
                hideBusinessSelectorAndTitle: true,
              },
            },
          ],
        },
        {
          path: "/self-assessment",
          name: "SelfAssessment",
          component: SelfAssessment,
          redirect: "/self-assessment/general-information",
          meta: {
            label: "label_selfAssessment_title",
          },
          children: [
            {
              path: "general-information",
              name: "SelfAssessmentGeneralInformation",
              component: SelfAssessmentGeneralInformation,
              meta: {
                label: "label_selfAssessment_general_title",
              },
            },
            {
              path: "staff",
              name: "SelfAssessmentStaff",
              component: SelfAssessmentStaff,
              meta: {
                label: "label_selfAssessment_staff_title",
              },
            },
            {
              path: "labor-conditions",
              name: "SelfAssessmentLaborConditions",
              component: SelfAssessmentLaborConditions,
              meta: {
                label: "label_selfAssessment_laborConditions_title",
              },
            },
            {
              path: "human-resources",
              name: "SelfAssessmentHumanResources",
              component: SelfAssessmentHumanResources,
              meta: {
                label: "label_selfAssessment_humanResources_title",
              },
            },
            {
              path: "employment-policies",
              name: "SelfAssessmentEmploymentPolicies",
              component: SelfAssessmentEmploymentPolicies,
              meta: {
                label: "label_selfAssessment_employmentPolicies_title",
              },
            },
            {
              path: "submit-for-review",
              name: "SelfAssessmentSubmitReview",
              component: SelfAssessmentSubmitReview,
              meta: {
                label: "label_selfAssessment_submitReview_title",
              },
            },
          ],
        },
        {
          path: "/violence-survey",
          name: "ViolenceSurvey",
          component: WorkspaceSurveyContainer,
          redirect: "/violence-survey/send-invitations",
          meta: {
            label: "label_violenceSurvey_title_short",
          },
          children: [
            {
              path: "send-invitations",
              name: "ViolenceSurveySendInvitations",
              component: WorkspaceSurvey,
              meta: {
                label: "label_sideMenu_violenceSurvey_sendInvitations",
              },
            },
            {
              path: "survey-management",
              name: "ViolenceSurveyManagement",
              component: WorkspaceSurveyManagement,
              meta: {
                label: "label_sideMenu_violenceSurvey_surveyManagement",
              },
            },
            {
              path: "survey-calculator",
              name: "ViolenceSurveyCalculator",
              component: ViolenceSurveyCalculator,
              meta: {
                label: "label_violenceSurvey_calculator_title",
              },
            },
          ],
        },
        {
          path: "/opinion-survey",
          name: "OpinionSurvey",
          component: OpinionSurvey,
          redirect: "/opinion-survey/send-invitations",
          meta: {
            label: "label_opinionSurvey_title_short",
          },
          children: [
            {
              path: "send-invitations",
              name: "OpinionSurveySendInvitations",
              component: OpinionSurveySendInvitations,
              meta: {
                label: "label_sideMenu_opinionSurvey_sendInvitations",
              },
            },
            {
              path: "survey-management",
              name: "OpinionSurveyManagement",
              component: OpinionSurveyManagment,
              meta: {
                label: "label_sideMenu_opinionSurvey_surveyManagement",
              },
            },
            {
              path: "survey-calculator",
              name: "OpinionSurveyCalculator",
              component: OpinionSurveyCalculator,
              meta: {
                label: "label_opinionSurvey_calculator_title",
              },
            },
          ],
        },
        {
          path: "/reports",
          redirect: "/reports/gender-gap",
          name: "Reports",
          component: Reports,
          meta: {
            label: "label_reports_title",
          },
          children: [
            {
              path: "gender-gap",
              name: "ReportsGenderGap",
              component: ReportsGenderGap,
              meta: {
                label: "label_reports_genderGap_title",
              },
            },
            {
              path: "gender-gap/:pillar",
              name: "ReportsGenderGapPillar",
              component: ReportsGenderGapPillar,
              meta: {
                label: "label_reports_genderGap_title",
              },
            },
            {
              path: "gender-gap/:pillar/:indicator",
              name: "ReportsGenderGapIndicator",
              component: ReportsGenderGapIndicator,
              meta: {
                label: "label_reports_genderGap_title",
              },
            },
            {
              path: "comparative",
              name: "Reportscomparative",
              component: ReportsComparative,
              meta: {
                label: "label_advancedData_compare_title",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "consolidated",
              name: "Reportsconsolidated",
              component: ReportsConsolidated,
              meta: {
                label: "label_advancedData_consolidate_title",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "consolidated/:pillar",
              name: "ReportsConsolidatedPillar",
              component: ReportsConsolidatedPillar,
              meta: {
                label: "label_advancedData_consolidate_title",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "consolidated/:pillar/:indicator",
              name: "ReportsConsolidatedIndicator",
              component: ReportsConsolidatedIndicator,
              meta: {
                label: "label_advancedData_consolidate_title",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "comparative/:pillar",
              name: "ReportsComparativePillar",
              component: ReportsComparativePillar,
              meta: {
                label: "label_advancedData_compare_title",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "management-report",
              name: "ReportsManagementReport",
              component: ReportsManagementReport,
              meta: {
                label: "label_reports_managementReport_title",
              },
            },
            {
              path: "opinion-survey",
              name: "ReportsOpinionSurvey",
              component: ReportsOpinionSurvey,
              meta: {
                label: "label_reports_opinionSurvey_title",
              },
            },
            {
              path: "violence-survey",
              name: "ReportsViolenceSurvey",
              component: ReportsViolenceSurvey,
              meta: {
                label: "label_reports_violenceSurvey_dynamic_title",
              },
            },
            {
              path: "organizational-violence",
              name: "ReportsOrganizationalViolence",
              component: ReportsOrganizationalViolence,
              meta: {
                label: "label_reports_violenceSurvey_title",
              },
            },
          ],
        },
        {
          path: "/configuration",
          name: "Configuration",
          component: Configuration,
          meta: {
            label: "label_configuration_title",
            hideBusinessSelectorAndTitle: true,
          },
          children: [
            ...tableListRoutes,
            ...tableViewRoutes,
            {
              path: "access-control",
              name: "ConfigurationAccessControl",
              component: ConfigurationAccessControl,
              meta: {
                label: "label_sideMenu_configuration_accessControl",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "createUser",
              name: "ConfigurationCreateUser",
              component: ConfigurationCreateUser,
              meta: {
                label: "label_sideMenu_configuration_createUser",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "wizard",
              name: "ConfigurationWizard",
              component: ConfigurationWizard,
              meta: {
                label: "label_sideMenu_configuration_wizard",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "wizardAdmin",
              name: "ConfigurationWizardAdmin",
              component: ConfigurationWizardAdmin,
              meta: {
                label: "label_sideMenu_configuration_wizard_admin",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "accessControlTemplate",
              name: "accessControlTemplate",
              component: ConfigurationAccessControlTemplate,
              meta: {
                label: "label_sideMenu_configuration_account_template",
                hideBusinessSelectorAndTitle: true,
              },
            },
            {
              path: "createAccessControl",
              name: "createAccessControl",
              component: ConfigurationCreateAccessControl,
              meta: {
                label: "label_sideMenu_configuration_access_control",
                hideBusinessSelectorAndTitle: true,
              },
            },
          ],
        },
      ],
    },
    {
      path: "/logout",
      beforeEnter: function (to, from, next) {
        // logout()
        next("/");
      },
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  console.log("getLang: ", store.getters.getLang);
  console.log("Domain: ", window.location.hostname);
  console.log(to);
  console.log('getting url',)

  console.log(getUrlForCurrentDomain(),window.location.hostname)
  if (store.getters.getLang === "labels") {
    console.log(getFrontendUrl('es'),'includes',window.location.hostname)
    if (getFrontendUrl('es').includes(window.location.hostname)) {
      await store.dispatch("setLangNew", "es");
    } else if (getFrontendUrl('pt').includes(window.location.hostname)) {
      await store.dispatch("setLangNew", "pt");
    } else {
      await store.dispatch("setLangNew", "en");
    }
  } else {
    await store.dispatch("setLangNew", store.getters.getLang);
  }
  if (store.getters.isAuthenticated) {
    if (to.name !== "login") {
      axiosCall({url: "UserAccounts/touch", method: "GET"});
    }
    if (
      store.getters.getUserAccount &&
      store.getters.getUserAccount.numberOfCompanies > 0 &&
      (!store.getters.getCurrentBusiness?.id ||
        typeof store.getters.getCurrentSnapshot?.snapshotId === "undefined" ||
        typeof store.getters.getBusiness?.id === "undefined")
    ) {
      try {
        await store.dispatch("USERACCOUNTS_BUSINESS");
        await store.dispatch("BUSINESS_GET");
        await store.dispatch("SNAPSHOTS_GET");
      } catch (e) {
        console.log(e);
        await this.router.push("/home");
      }
    }
    if (store.getters.getOptionLists.length === 0) {
      try {
        await store.dispatch("OPTION_LIST_GET");
      } catch (e) {
        console.log(e);
        await this.router.push("/home");
      }
    }
  }
  next();
});

export default router;
